import { render, staticRenderFns } from "./RapportagesBase.vue?vue&type=template&id=1f1b9450&scoped=true&"
import script from "./RapportagesBase.vue?vue&type=script&lang=js&"
export * from "./RapportagesBase.vue?vue&type=script&lang=js&"
import style0 from "./RapportagesBase.vue?vue&type=style&index=0&id=1f1b9450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1b9450",
  null
  
)

export default component.exports